<template>
  <ModelEditFormPriceAgreement
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="project"
    show-surcharge-modifier
    framed
    @input="wasChanged = true"
    @surcharge-input="wasChanged = true"
  />
</template>

<script setup lang="ts">
import { Project } from "@/models/project.model"
import { inject } from "vue"
import type { SaleItem } from "@/models/sale-item.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import ModelEditFormPriceAgreement from "@/components/administrative_item/ModelEditFormPriceAgreement.vue"
import { ProjectSaleItem } from "@/models/project-sale-item.model"
import { useProjectsSaleItemsStore } from "@/store/projects-sale-items.store"

const props = defineProps<{
  project: Project
  saleItem: SaleItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<SaleItem, ProjectSaleItem>(
    props.project,
    props.saleItem,
    useProjectsSaleItemsStore(),
    inject("projectSaleItemController")!,
    ProjectSaleItem
  )

defineExpose({ savePriceAgreement })
</script>

<style scoped></style>
